export default __webpack_public_path__ + "static/media/illustration-algostudy-n-m.a78094f4.webp";